import roles from "@/utils/roles.json";
import store from "@/store/index";

function getAllowRole(route_name) {
  const result = roles.filter(({ allow_page_name }) =>
    allow_page_name.some((elm) => elm.includes(route_name))
  );
  let newArr = [];
  result.forEach((elm) => {
    newArr = [...newArr, elm.role_name];
  });

  return newArr;
}

function getAllowActionByCurrRole(action) {
  const currRole = store.getters["userAuth/getUserRoleCode"];
  let objRole = roles.find(({ role_name }) => role_name.includes(currRole));
  return objRole.allow_action?.length > 0
    ? objRole.allow_action.includes(action)
    : false;
}
function getCurrentRole() {
  return store.getters["userAuth/getUserRoleCode"];
}
export { getAllowRole, getAllowActionByCurrRole, getCurrentRole };
